import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  Host,
  Input,
  Optional,
  SkipSelf,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import {
  ColumnBase,
  ColumnComponent,
  IdService,
} from '@progress/kendo-angular-grid';

/**
 * https://www.telerik.com/forums/making-a-reusable-customised-grid-column
 */
@Component({
  selector: 'kendo-grid-column-ex-boolean',
  providers: [
    {
      provide: ColumnBase,
      useExisting: forwardRef(() => KendoGridColumnExBooleanComponent),
    },
  ],
  template: `
    <ng-template #myCellTemplate let-dataItem>
      <input
        type="checkbox"
        [checked]="dataItem[field]"
        class="k-checkbox"
        disabled
      />
      <label class="k-checkbox-label">{{ label }}</label>
    </ng-template>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KendoGridColumnExBooleanComponent extends ColumnComponent {
  @Input() label: string;

  constructor(
    _el: ElementRef,
    @Optional() @Host() @SkipSelf() parent?: ColumnBase,
    @Optional() idService?: IdService
  ) {
    super(parent, idService);
  }

  /* NOTE:
   *
   * For some reason that what worked directly in an A8 app (where KendoGridColumnExBooleanComponent wasn't imported by a module)...
   * ...somehow stopped working here.
   *
   * As a fallback we use TemplateRef<unknown> with a template reference to address it.
   * Also the final public get templateRef(): TemplateRef<unknown> code changed a bit, as we now have a TemplateRef<unknown> and not a CellTemplateDirective child component (notice change from viewTemplate to viewTemplateRef).
   */

  @ViewChild('myCellTemplate') viewTemplateRef: TemplateRef<unknown>;

  //@ts-ignore
  public get templateRef(): TemplateRef<unknown> {
    const hasTemplate = this.template && this.template.templateRef;
    const hasViewTemplate = this.viewTemplateRef;
    return hasTemplate
      ? this.template.templateRef
      : hasViewTemplate
        ? this.viewTemplateRef
        : undefined;
  }
}
